let oosApiBaseUrl

export default {oosApiBaseUrl}
